import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { AppState } from 'src/app/store/app.reducer';
import { selectHelpList } from 'src/app/store/help/help.selector';
import { SectionData } from 'src/app/model/help';

@Component({
   selector: 'app-helper-list',
   templateUrl: './helper-list.component.html',
   changeDetection: ChangeDetectionStrategy.Default,
})

export class HelperListComponent implements OnInit, OnDestroy {
	@Input() controller: boolean;

   // Observables and subscriptions
   helpList$: Observable < SectionData[] | undefined > ;
   helpListSub: Subscription | undefined;

   sections: SectionData[];

   constructor(
      private store: Store < AppState > ,
   ) {
      this.initSelectors();
   }

   ngOnInit() {
      this.subscribeAll();
   }

   ngOnDestroy(): void {
      this.helpListSub?.unsubscribe();
   }

   initSelectors(): void {
      this.helpList$ = this.store.select(selectHelpList);
   }

   subscribeAll(): void {
      this.helpListSub = this.helpList$.subscribe((sections) => {
         this.sections = sections;
      });
   }
}
